import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { PrintHelper } from "@/Common/Helpers/PrintHelper";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { PatientMedicalSummaryHelper } from "@/Patient/Helpers/PatientMedicalSummaryHelper";
import { PatientStore } from "@/Patient/Stores/PatientStore";
import { MedicationNoteService } from "./MedicationNoteService";

class PatientMedicationTabResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.Myle_UpsertMedication, this.RefreshMedications);
        this.RegisterOperation(ServerOperations.Server.Myle_DeleteMedication, this.RefreshMedications);
        this.RegisterOperation(ServerOperations.Server.Myle_UpdateMedicationDates, this.RefreshMedications);

        this.RegisterOperation(ServerOperations.Server.Myle_UpdateMedicationStatus, this.RefreshMedications);
        this.RegisterOperation(ServerOperations.Server.Myle_Patient_EMRTemplate_Get, this.Patient_EMRTemplate_Get);

        this.RegisterOperation(ServerOperations.Server.Myle_Patient_Medication_GeneratePDF, this.PrintMedication);
        this.RegisterOperation(ServerOperations.Server.Myle_ToggleFavoriteMedicalProblem, this.ToggleFavoriteMedicalProblem);
    }

    private ToggleFavoriteMedicalProblem(response: ServerEvent): void {
        if (!response.Data.Success)
            return;

        const diagnosisId: string = response.Data.DiagnosisId;
        const isRemove: boolean = response.Data.IsRemove;
        const reloadFavorites: boolean = response.Data.ReloadFavorites;

        const employeeId = sessionStore.getCurrentEmployee().ContactFacetId;
        if (cacheStore.FavoriteDiagnoses) {
            for (let diagnosis of cacheStore.FavoriteDiagnoses.toArray()) {
                if (diagnosis.Model.Id == diagnosisId) {
                    diagnosis.Model.EmployeeId = isRemove && diagnosis.Model.EmployeeId == employeeId
                        ? GuidHelper.Empty()
                        : employeeId;
                }
            }
        }

        if (reloadFavorites)
            cacheStore.refreshFavoriteDiagnoses();
    }

    private PrintMedication(response: ServerEvent): void {
        PrintHelper.ShowPrintPreviewFileName(response.Data["FileName"]);
    }

    private RefreshMedications(response: ServerEvent, store: PatientStore): void {
        var Success: boolean = response.Data.Success;
        if (Success) {
            store.ActionsMedicationTab.ReloadMedications(response.PatientId);
            // store.ActionsMedicalSummary.LoadPatientCumulativeProfile(store.ActivePatientContactId, null, true, false, false, store);
        }
    }

    private Patient_EMRTemplate_Get(response: ServerEvent, store: PatientStore): void {
        let ERMTemplateType: number = response.Data.EMRTemplateType;
        if (ERMTemplateType == 8) {
            response.Data.MedicalItems.sort((a, b) => { if (a.EMRTemplateSortIndex > b.EMRTemplateSortIndex) return 1; if (a.EMRTemplateSortIndex < b.EMRTemplateSortIndex) return -1; return 0; });
            let unfilteredMedicationModels = PatientMedicalSummaryHelper.InitMedications(response.Data.MedicalItems);

            // reset complete medical list in model
            patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId] =
                patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId].set("MedicalItemsMedicationAndPrescription", Immutable.List(unfilteredMedicationModels));

            // refilter complete medical list according to patient active medication grid filters and sort orders
            let filteredMedicationModels = patientStore.filterAndSortMedication(response.PatientId, unfilteredMedicationModels);

            patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId] = patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId]
                .set("MedicationNotes", new MedicationNoteService(response.Data.MedicationNotes, response.Data.MedicalItems));

            // reset filtered medical list in model
            patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId] =
                patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId].set("FilteredMedicalItemsMedicationAndPrescription", Immutable.List(filteredMedicationModels));

            let prescriptions = PatientMedicalSummaryHelper.CreatePrescriptionGroupsFromMedications(patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId].get("MedicalItemsMedicationAndPrescription"));
            if (!!prescriptions) {
                const currentPrescriptionsGeneralInstructionDictionary: Record<string, string> =
                    patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId].get("PrescriptionsGeneralInstructions");
                prescriptions.forEach(p => p.GeneralInstruction = currentPrescriptionsGeneralInstructionDictionary[p.PrescriptionId]);
            }
            patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId] = patientStore.PatientMedicalSummaryModels[response.Data.PatientContactId].set("Prescriptions", Immutable.List(prescriptions));
            store.ActionsMedicalNote.LoadSignedAuthorizations({ prescriptonIds: prescriptions.map(p => p.PrescriptionId) });
        }
    }
}

export { PatientMedicationTabResponseHandler };
